const debugInterceptorFactory:ng.IHttpInterceptorFactory =
    ($timeout:ng.ITimeoutService) => {
      return {
        response: (response:any) => {
          return $timeout(() => {
            return response;
          }, 0);
        }
      }
    };

debugInterceptorFactory.$inject = ['$timeout'];

const configInterceptor = ($httpProvider:ng.IHttpProvider) => {
  $httpProvider.interceptors.push(debugInterceptorFactory);
};
configInterceptor.$inject = ['$httpProvider'];

export default configInterceptor;



/** WEBPACK FOOTER **
 ** ./app/utils/debug.interceptor.ts
 **/